module.exports = __webpack_public_path__ + "img/instagram.0733f70b.svg";